import { init } from '@updater/identity';

// Module-level guard so init() runs once per page load, however many times
// this is called.
let hasInited = false;

/**
 * Resolves the device's `updUuid` before React renders anything, so every
 * consumer reads one already-minted value from `getCurrentProfile()` instead
 * of racing an effect for it. Called at module scope in `_app`.
 *
 * Attributes that come from the qual (promoId, partnerUserId) are not known
 * yet at this point; `IdentityInit` sets them once the qual has rendered.
 */
export function initIdentity(): void {
  if (hasInited || typeof window === 'undefined') return;
  hasInited = true;
  init({});
}
